<template>
  <v-card class="elevation-0" color="transparent">
    <v-card-title>
      <span>{{ title }}</span>

      <v-divider
        class="mx-4"
        vertical
      ></v-divider>

      <span class="caption">{{ hintText }}</span>

      <v-spacer></v-spacer>

      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Rechercher"
        single-line
        hide-details
        class="mt-0 pt-0"
      ></v-text-field>
    </v-card-title>

    <v-data-table
      :headers="headers"
      :items="filteredJobs"
      :search="search"
      multi-sort
      @click:row="applyToJob"
      class="elevation-1 rounded-lg row-pointer"
      :loading="jobsAreLoading"
      loading-text="Chargement des emplois vacants..."
      no-data-text="Aucun emploi vacant disponible"
      no-results-text="Aucun emploi vacant correspondant trouvé"
      show-expand
      :page.sync="page"
      hide-default-footer
      @page-count="pageCount = $event"
    >
      <template v-slot:item.volume="{ item }">
        {{ item.volume }} {{ item.type_emploi === 'ENS' ? '/10' : '/38' }}
      </template>

      <template v-slot:expanded-item="{ headers, item }">
        <td :colspan="headers.length" class="py-3">
          <div class="caption font-weight-bold text--secondary">DESCRIPTION DE L'EMPLOI</div>
          <div v-html="item.description" class="mt-2"></div>
        </td>
      </template>

      <template v-slot:item.data-table-expand="{ item, isExpanded, expand }">
        <v-btn icon @click.stop="expand(true)" v-if="item.description && !isExpanded">
          <v-icon color="primary">mdi-information</v-icon>
        </v-btn>
        <v-btn icon @click.stop="expand(false)" v-if="item.description && isExpanded">
          <v-icon>mdi-chevron-up</v-icon>
        </v-btn>
      </template>
    </v-data-table>

    <v-pagination
      class="mt-2"
      v-model="page"
      :length="pageCount"
      :total-visible="7"
    ></v-pagination>

  </v-card>
</template>

<script>
const axios = require('axios').default;

export default {
  name: 'JobsTable',

  props: {
    jobType: String,
  },

  data: () => ({
    page: 1,
    pageCount: 0,
    jobs: [],
    jobsAreLoading: false,
    search: '',
  }),

  created() {
    this.getJobs();
  },

  computed: {
    hintText() {
      return this.$store.getters.isAuth
        ? 'Cliquez sur un emploi pour y postuler'
        : 'Connectez-vous pour y postuler';
    },
    filteredJobs() {
      return this.jobs.filter((job) => job.type_emploi === this.jobType);
    },
    headers() {
      if (this.jobType === 'ADM') {
        return [
          { text: 'NUMERO', value: 'numero' },
          { text: 'FONCTION', value: 'fonction' },
          { text: 'NIVEAU', value: 'nom' },
          { text: 'SERVICE', value: 'service' },
          { text: 'VOLUME DE LA CHARGE', value: 'volume' },
          { text: 'IMPLANTATION', value: 'implantations' },
          { text: '', value: 'data-table-expand' },
        ];
      }
      return [
        { text: 'NUMERO', value: 'numero' },
        { text: 'COURS A CONFERER', value: 'nom' },
        { text: 'FONCTION', value: 'fonction' },
        { text: 'VOLUME DE LA CHARGE', value: 'volume' },
        { text: 'IMPLANTATION', value: 'implantations' },
        { text: '', value: 'data-table-expand' },
      ];
    },
    title() {
      return (this.jobType === 'ADM' ? 'Administratif' : 'Enseignement');
    },
  },

  methods: {
    async getJobs() {
      try {
        this.jobsAreLoading = true;
        const response = await axios.get('emplois_vacants');
        if (response.data !== 'Pas d\'emplois vacants publiés') {
          this.jobs = response.data;
        }
      } catch (error) {
        this.$store.commit('SET_SNACKBAR', {
          isActive: true,
          text: 'Impossible de récupérer les emplois vacants, rechargez la page',
        });
      } finally {
        this.jobsAreLoading = false;
      }
    },

    applyToJob(job) {
      this.$router.push(`/apply/${job.id}`);
    },
  },
};
</script>

<style scoped>

.row-pointer >>> tbody tr :hover {
  cursor: pointer;
}

</style>
